import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"

// function ToggleSidebarButton({ className }) {
//     return (
//         <label
//             className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
//             for="toggle-mobile-sidebar"
//         >
//             <Icon name="close" />
//         </label>
//     )
// }

export default function SideBar({ sidebarIsShown, onToggleSidebar }) {
    const { loading, facets } = useFacets()

    return facets?.length > 0 ? (
        <>
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class={`ns-sidebar-wrapper ${sidebarIsShown ? 'ns-sidebar-active' : ''}`}
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white">
                    <div class="ns-sidebar-header ns-sidebar-title">
                        <span class="ns-filters-text">Filters</span>
                        <svg onClick={onToggleSidebar} class="ns-icon-filter-close" width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13" stroke="#000017" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M1 1L13 13" stroke="#000017" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        {/* <ToggleSidebarButton onToggleSidebar={onToggleSidebar} /> */}
                    </div>
                    <div class="ns-sidebar-menu ns-sidebar-inner">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    {sidebarIsShown && (
                        <div onClick={onToggleSidebar} class="ns-view-products-wrapper">
                            <span class="ns-view-products-btn">View products</span>
                        </div>
                    )}
                </div>
            </div>

            {sidebarIsShown && (
                <div onClick={onToggleSidebar} class="ns-backdrop-overlay"></div>
            )}
        </>
    ) : (
        ""
    )
}
